console.log("adminAreaConstants loaded");

export const adminAreaConstants = {
    GET_ALL_ORGANIZATIONS_REQUEST: "GET_ALL_ORGANIZATIONS_REQUEST",
    GET_ALL_ORGANIZATIONS_SUCCESS: "GET_ALL_ORGANIZATIONS_SUCCESS",
    GET_ALL_ORGANIZATIONS_FAILURE: "GET_ALL_ORGANIZATIONS_FAILURE",

    GET_ALL_SELECTABLE_ORGANIZATIONS_REQUEST: "GET_ALL_SELECTABLE_ORGANIZATIONS_REQUEST",
    GET_ALL_SELECTABLE_ORGANIZATIONS_SUCCESS: "GET_ALL_SELECTABLE_ORGANIZATIONS_SUCCESS",
    GET_ALL_SELECTABLE_ORGANIZATIONS_FAILURE: "GET_ALL_SELECTABLE_ORGANIZATIONS_FAILURE",
    GET_ORGANIZATION_NAMES_REQUEST: "GET_ORGANIZATION_NAMES_REQUEST",
    GET_ORGANIZATION_NAMES_SUCCESS: "GET_ORGANIZATION_NAMES_SUCCESS",
    GET_ORGANIZATION_NAMES_FAILURE: "GET_ORGANIZATION_NAMES_FAILURE",

    GET_REDUCED_ORGANIZATION_FOR_TESTING_REQUEST: "GET_REDUCED_ORGANIZATION_FOR_TESTING_REQUEST",
    GET_REDUCED_ORGANIZATION_FOR_TESTING_SUCCESS: "GET_REDUCED_ORGANIZATION_FOR_TESTING_SUCCESS",
    GET_REDUCED_ORGANIZATION_FOR_TESTING_FAILURE: "GET_REDUCED_ORGANIZATION_FOR_TESTING_FAILURE",

    GET_ADMIN_AREA_ORGANIZATION_REQUEST: "GET_ADMIN_AREA_ORGANIZATION_REQUEST",
    GET_ADMIN_AREA_ORGANIZATION_SUCCESS: "GET_ADMIN_AREA_ORGANIZATION_SUCCESS",
    GET_ADMIN_AREA_ORGANIZATION_FAILURE: "GET_ADMIN_AREA_ORGANIZATION_FAILURE",

    SET_ADMIN_AREA_EDIT_ORGANIZATION: "SET_ADMIN_AREA_EDIT_ORGANIZATION",
    SET_INITIAL_ADMIN_AREA_STATE: "SET_INITIAL_ADMIN_AREA_STATE",
    RESET_EDIT_ORGANIZATION_TO_CONFIGURATION: "RESET_EDIT_ORGANIZATION_TO_CONFIGURATION",

    GET_ORGANIZATIONS_WITH_BILLING_ENABLED_REQUEST: "GET_ORGANIZATIONS_WITH_BILLING_ENABLED_REQUEST",
    GET_ORGANIZATIONS_WITH_BILLING_ENABLED_SUCCESS: "GET_ORGANIZATIONS_WITH_BILLING_ENABLED_SUCCESS",
    GET_ORGANIZATIONS_WITH_BILLING_ENABLED_FAILURE: "GET_ORGANIZATIONS_WITH_BILLING_ENABLED_FAILURE",

    UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_SUCCESS: "UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_SUCCESS",
    UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_REQUEST: "UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_REQUEST",
    UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_FAILURE: "UPDATE_ORGANIZATION_WITH_BILLING_ENABLED_FAILURE",

    DELETE_ADMIN_AREA_ORGANIZATION_REQUEST: "DELETE_ADMIN_AREA_ORGANIZATION_REQUEST",
    DELETE_ADMIN_AREA_ORGANIZATION_SUCCESS: "DELETE_ADMIN_AREA_ORGANIZATION_SUCCESS",
    DELETE_ADMIN_AREA_ORGANIZATION_FAILURE: "DELETE_ADMIN_AREA_ORGANIZATION_FAILURE",

    UPDATE_ADMIN_AREA_ORGANIZATION_REQUEST: "UPDATE_ADMIN_AREA_ORGANIZATION_REQUEST",
    UPDATE_ADMIN_AREA_ORGANIZATION_SUCCESS: "UPDATE_ADMIN_AREA_ORGANIZATION_SUCCESS",
    UPDATE_ADMIN_AREA_ORGANIZATION_FAILURE: "UPDATE_ADMIN_AREA_ORGANIZATION_FAILURE",

    GET_ADMIN_AREA_USERS_REQUEST: "GET_ADMIN_AREA_USERS_REQUEST",
    GET_ADMIN_AREA_USERS_SUCCESS: "GET_ADMIN_AREA_USERS_SUCCESS",
    GET_ADMIN_AREA_USERS_FAILURE: "GET_ADMIN_AREA_USERS_FAILURE",

    GET_ADMIN_AREA_USER_BY_FILTER_REQUEST: "GET_ADMIN_AREA_USER_BY_FILTER_REQUEST",
    GET_ADMIN_AREA_USER_BY_FILTER_SUCCESS: "GET_ADMIN_AREA_USER_BY_FILTER_SUCCESS",
    GET_ADMIN_AREA_USER_BY_FILTER_FAILURE: "GET_ADMIN_AREA_USER_BY_FILTER_FAILURE",

    GET_ADMIN_AREA_USER_REQUEST: "GET_ADMIN_AREA_USER_REQUEST",
    GET_ADMIN_AREA_USER_SUCCESS: "GET_ADMIN_AREA_USER_SUCCESS",
    GET_ADMIN_AREA_USER_FAILURE: "GET_ADMIN_AREA_USER_FAILURE",

    DELETE_ADMIN_AREA_USER_REQUEST: "DELETE_ADMIN_AREA_USER_REQUEST",
    DELETE_ADMIN_AREA_USER_SUCCESS: "DELETE_ADMIN_AREA_USER_SUCCESS",
    DELETE_ADMIN_AREA_USER_FAILURE: "DELETE_ADMIN_AREA_USER_FAILURE",

    UPDATE_ADMIN_AREA_USER_REQUEST: "UPDATE_ADMIN_AREA_USER_REQUEST",
    UPDATE_ADMIN_AREA_USER_SUCCESS: "UPDATE_ADMIN_AREA_USER_SUCCESS",
    UPDATE_ADMIN_AREA_USER_FAILURE: "UPDATE_ADMIN_AREA_USER_FAILURE",

    REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_REQUEST: "REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_REQUEST",
    REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_SUCCESS: "REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_SUCCESS",
    REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_FAILURE: "REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_FAILURE",

    CREATE_NEW_RESET_PASSWORD_LINK_REQUEST: "CREATE_NEW_RESET_PASSWORD_LINK_REQUEST",
    CREATE_NEW_RESET_PASSWORD_LINK_SUCCESS: "CREATE_NEW_RESET_PASSWORD_LINK_SUCCESS",
    CREATE_NEW_RESET_PASSWORD_LINK_FAILURE: "CREATE_NEW_RESET_PASSWORD_LINK_FAILURE",

    TOGGLE_SHOPIFY_BASIC_COUNT_MODAL_FOR_ORGANIZATION: "TOGGLE_SHOPIFY_ORDERS_MODAL",
    TOGGLE_SHOPIFY_ADVANCED_COUNT_MODAL_FOR_ORGANIZATION: "TOGGLE_SHOPIFY_ORDERS_ADVANCED_MODAL",
    TOGGLE_CHARGEBEE_MODAL_FOR_ORGANIZATION: "TOGGLE_CHARGEBEE_ORGANIZATION_MODAL",
    TOGGLE_STRIPE_BILLING_MODAL_FOR_ORGANIZATION: "TOGGLE_STRIPE_BILLING_ORGANIZATION_MODAL",
    TOGGLE_SHOPIFY_PAYMENTS_MODAL_FOR_ORGANIZATION: "TOGGLE_SHOPIFY_PAYMENTS_MODAL_FOR_ORGANIZATION",
    TOGGLE_STRIPE_CHARGES_MODAL_FOR_ORGANIZATION: "TOGGLE_STRIPE_CHARGES_MODAL_FOR_ORGANIZATION",
    TOGGLE_TIKTOK_SHOP_MODAL_FOR_ORGANIZATION: "TOGGLE_TIKTOK_SHOP_MODAL_FOR_ORGANIZATION",
    TOGGLE_TIKTOK_PAYMENTS_MODAL_FOR_ORGANIZATION: "TOGGLE_TIKTOK_PAYMENTS_MODAL_FOR_ORGANIZATION",

    GET_SHOPIFY_ORDERS_AMOUNT_ALL_REQUEST: "GET_SHOPIFY_ORDERS_AMOUNT_ALL_REQUEST",
    GET_SHOPIFY_ORDERS_AMOUNT_ALL_SUCCESS: "GET_SHOPIFY_ORDERS_AMOUNT_ALL_SUCCESS",
    GET_SHOPIFY_ORDERS_AMOUNT_ALL_FAILURE: "GET_SHOPIFY_ORDERS_AMOUNT_ALL_FAILURE",

    GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_REQUEST: "GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_REQUEST",
    GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_SUCCESS: "GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_FAILURE: "GET_SHOPIFY_ORDERS_AMOUNT_FOR_CLIENT_FAILURE",

    GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_REQUEST: "GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_REQUEST",
    GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_SUCCESS: "GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_FAILURE: "GET_SHOPIFY_PAYMENTS_AMOUNT_FOR_CLIENT_FAILURE",

    GET_SHOPIFY_PAYMENTS_AMOUNT_REQUEST: "GET_SHOPIFY_PAYMENTS_AMOUNT_REQUEST",
    GET_SHOPIFY_PAYMENTS_AMOUNT_SUCCESS: "GET_SHOPIFY_PAYMENTS_AMOUNT_SUCCESS",
    GET_SHOPIFY_PAYMENTS_AMOUNT_FAILURE: "GET_SHOPIFY_PAYMENTS_AMOUNT_FAILURE",

    GET_STRIPE_CHARGES_AMOUNT_ALL_REQUEST: "GET_STRIPE_CHARGES_AMOUNT_ALL_REQUEST",
    GET_STRIPE_CHARGES_AMOUNT_ALL_SUCCESS: "GET_STRIPE_CHARGES_AMOUNT_ALL_SUCCESS",
    GET_STRIPE_CHARGES_AMOUNT_ALL_FAILURE: "GET_STRIPE_CHARGES_AMOUNT_ALL_FAILURE",

    GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_REQUEST: "GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_REQUEST",
    GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_SUCCESS: "GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_FAILURE: "GET_STRIPE_CHARGES_AMOUNT_FOR_CLIENT_FAILURE",

    CHARGE_ORGANIZATIONS_REQUEST: "CHARGE_ORGANIZATIONS_REQUEST",
    CHARGE_ORGANIZATIONS_SUCCESS: "CHARGE_ORGANIZATIONS_SUCCESS",
    CHARGE_ORGANIZATIONS_FAILURE: "CHARGE_ORGANIZATIONS_FAILURE",

    OPEN_DETAILED_PAGE: "OPEN_DETAILED_PAGE",

    CLEAR_BILLING_DATA: "CLEAR_BILLING_DATA",
    CLEAR_DELETION_ERROR_MESSAGES: "CLEAR_DELETION_ERROR_MESSAGES",
    CLEAR_ERROR_MESSAGE: "CLEAR_ERROR_MESSAGE",

    UNLOCK_TAX_CONSULTANT_DATA_REQUEST_REQUEST: "UNLOCK_TAX_CONSULTANT_DATA_REQUEST_REQUEST",
    UNLOCK_TAX_CONSULTANT_DATA_REQUEST_SUCCESS: "UNLOCK_TAX_CONSULTANT_DATA_REQUEST_SUCCESS",
    UNLOCK_TAX_CONSULTANT_DATA_REQUEST_FAILURE: "UNLOCK_TAX_CONSULTANT_DATA_REQUEST_FAILURE",

    GET_APP_STORE_ORGANIZATIONS_REQUEST: "GET_APP_STORE_ORGANIZATIONS_REQUEST",
    GET_APP_STORE_ORGANIZATIONS_SUCCESS: "GET_APP_STORE_ORGANIZATIONS_SUCCESS",
    GET_APP_STORE_ORGANIZATIONS_FAILURE: "GET_APP_STORE_ORGANIZATIONS_FAILURE",

    GET_ALL_APPLICATIONS_REQUEST: "GET_ALL_APPLICATIONS_REQUEST",
    GET_ALL_APPLICATIONS_SUCCESS: "GET_ALL_APPLICATIONS_SUCCESS",
    GET_ALL_APPLICATIONS_FAILURE: "GET_ALL_APPLICATIONS_FAILURE",

    SET_FILTER_PROPERTIES: "SET_FILTER_PROPERTIES",
    SET_USER_FILTER_PROPERTIES: "SET_USER_FILTER_PROPERTIES",

    GET_STRIPE_BILLING_AMOUNT_ALL_REQUEST: "GET_STRIPE_BILLING_AMOUNT_ALL_REQUEST",
    GET_STRIPE_BILLING_AMOUNT_ALL_SUCCESS: "GET_STRIPE_BILLING_AMOUNT_ALL_SUCCESS",
    GET_STRIPE_BILLING_AMOUNT_ALL_FAILURE: "GET_STRIPE_BILLING_AMOUNT_ALL_FAILURE",

    GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_REQUEST: "GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_REQUEST",
    GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_SUCCESS: "GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_FAILURE: "GET_STRIPE_BILLING_AMOUNT_FOR_CLIENT_FAILURE",

    GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_REQUEST: "GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_REQUEST",
    GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_SUCCESS: "GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_SUCCESS",
    GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_FAILURE: "GET_STRIPE_BILLING_AMOUNT_FOR_ORGANIZATION_FAILURE",

    GET_CHARGEBEE_AMOUNT_ALL_REQUEST: "GET_CHARGEBEE_AMOUNT_ALL_REQUEST",
    GET_CHARGEBEE_AMOUNT_ALL_SUCCESS: "GET_CHARGEBEE_AMOUNT_ALL_SUCCESS",
    GET_CHARGEBEE_AMOUNT_ALL_FAILURE: "GET_CHARGEBEE_AMOUNT_ALL_FAILURE",

    GET_CHARGEBEE_AMOUNT_FOR_CLIENT_REQUEST: "GET_CHARGEBEE_AMOUNT_FOR_CLIENT_REQUEST",
    GET_CHARGEBEE_AMOUNT_FOR_CLIENT_SUCCESS: "GET_CHARGEBEE_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_CHARGEBEE_AMOUNT_FOR_CLIENT_FAILURE: "GET_CHARGEBEE_AMOUNT_FOR_CLIENT_FAILURE",

    GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_REQUEST: "GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_REQUEST",
    GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_SUCCESS: "GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_SUCCESS",
    GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_FAILURE: "GET_CHARGEBEE_AMOUNT_FOR_ORGANIZATION_FAILURE",

    TOGGLE_WOO_COMMERCE_ORDERS_ADVANCED_MODAL_FOR_ORGANIZATION: "TOGGLE_WOO_COMMERCE_ORDERS_ADVANCED_MODAL",
    TOGGLE_WOO_COMMERCE_ORDERS_MODAL_FOR_ORGANIZATION: "TOGGLE_WOO_COMMERCE_ORDERS_MODAL",

    GET_INTEGRATION_COUNT_FOR_ORGANIZATION_REQUEST: "GET_INTEGRATION_COUNT_FOR_ORGANIZATION_REQUEST",
    GET_INTEGRATION_COUNT_FOR_ORGANIZATION_SUCCESS: "GET_INTEGRATION_COUNT_FOR_ORGANIZATION_SUCCESS",
    GET_INTEGRATION_COUNT_FOR_ORGANIZATION_FAILURE: "GET_INTEGRATION_COUNT_FOR_ORGANIZATION_FAILURE",

    GET_ADVANCED_INTEGRATION_COUNT_REQUEST: "GET_ADVANCED_INTEGRATION_COUNT_REQUEST",
    GET_ADVANCED_INTEGRATION_COUNT_SUCCESS: "GET_ADVANCED_INTEGRATION_COUNT_SUCCESS",
    GET_ADVANCED_INTEGRATION_COUNT_FAILURE: "GET_ADVANCED_INTEGRATION_COUNT_FAILURE",

    GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_REQUEST: "GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_REQUEST",
    GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_SUCCESS: "GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_SUCCESS",
    GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_FAILURE: "GET_WOO_COMMERCE_ORDERS_AMOUNT_ALL_FAILURE",

    GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_REQUEST: "GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_REQUEST",
    GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_SUCCESS: "GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_SUCCESS",
    GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_FAILURE: "GET_WOO_COMMERCE_ORDERS_AMOUNT_FOR_CLIENT_FAILURE",

    GET_ORDER_TOOL_DATA_REQUEST: "GET_ORDER_TOOL_DATA_REQUEST",
    GET_ORDER_TOOL_DATA_SUCCESS: "GET_ORDER_TOOL_DATA_SUCCESS",
    GET_ORDER_TOOL_DATA_FAILURE: "GET_ORDER_TOOL_DATA_FAILURE",

    GET_CHARGEBEE_AUTOSETUP_MESSAGES_REQUEST: "GET_CHARGEBEE_AUTOSETUP_MESSAGES_REQUEST",
    GET_CHARGEBEE_AUTOSETUP_MESSAGES_SUCCESS: "GET_CHARGEBEE_AUTOSETUP_MESSAGES_SUCCESS",
    GET_CHARGEBEE_AUTOSETUP_MESSAGES_FAILURE: "GET_CHARGEBEE_AUTOSETUP_MESSAGES_FAILURE",

    SEARCH_STRIPE_BILLING_TOOL_REQUEST: "SEARCH_STRIPE_BILLING_TOOL_REQUEST",
    SEARCH_STRIPE_BILLING_TOOL_SUCCESS: "SEARCH_STRIPE_BILLING_TOOL_SUCCESS",
    SEARCH_STRIPE_BILLING_TOOL_FAILURE: "SEARCH_STRIPE_BILLING_TOOL_FAILURE",

    GET_ADMIN_THREAD_DUMP_REQUEST: "GET_ADMIN_THREAD_DUMP_REQUEST",
    GET_ADMIN_THREAD_DUMP_SUCCESS: "GET_ADMIN_THREAD_DUMP_SUCCESS",
    GET_ADMIN_THREAD_DUMP_FAILURE: "GET_ADMIN_THREAD_DUMP_FAILURE",

    STOP_THREAD_DUMP_REQUEST: "STOP_THREAD_DUMP_REQUEST",
    STOP_THREAD_DUMP_SUCCESS: "STOP_THREAD_DUMP_SUCCESS",
    STOP_THREAD_DUMP_FAILURE: "STOP_THREAD_DUMP_FAILURE",

    GET_USER_LOGIN_STATISTICS_REQUEST: "GET_USER_LOGIN_STATISTICS_REQUEST",
    GET_USER_LOGIN_STATISTICS_SUCCESS: "GET_USER_LOGIN_STATISTICS_SUCCESS",
    GET_USER_LOGIN_STATISTICS_FAILURE: "GET_USER_LOGIN_STATISTICS_FAILURE",

    GET_AMAZON_PAYOUT_FEES_REQUEST: "GET_AMAZON_PAYOUT_FEES_REQUEST",
    GET_AMAZON_PAYOUT_FEES_SUCCESS: "GET_AMAZON_PAYOUT_FEES_SUCCESS",
    GET_AMAZON_PAYOUT_FEES_FAILURE: "GET_AMAZON_PAYOUT_FEES_FAILURE",

    CREATE_AMAZON_PAYOUT_FEE_REQUEST: "CREATE_AMAZON_PAYOUT_FEE_REQUEST",
    CREATE_AMAZON_PAYOUT_FEE_SUCCESS: "CREATE_AMAZON_PAYOUT_FEE_SUCCESS",
    CREATE_AMAZON_PAYOUT_FEE_FAILURE: "CREATE_AMAZON_PAYOUT_FEE_FAILURE",

    EDIT_AMAZON_PAYOUT_FEE_REQUEST: "EDIT_AMAZON_PAYOUT_FEE_REQUEST",
    EDIT_AMAZON_PAYOUT_FEE_SUCCESS: "EDIT_AMAZON_PAYOUT_FEE_SUCCESS",
    EDIT_AMAZON_PAYOUT_FEE_FAILURE: "EDIT_AMAZON_PAYOUT_FEE_FAILURE",

    DELETE_AMAZON_PAYOUT_FEE_REQUEST: "DELETE_AMAZON_PAYOUT_FEE_REQUEST",
    DELETE_AMAZON_PAYOUT_FEE_SUCCESS: "DELETE_AMAZON_PAYOUT_FEE_SUCCESS",
    DELETE_AMAZON_PAYOUT_FEE_FAILURE: "DELETE_AMAZON_PAYOUT_FEE_FAILURE",

    GET_AMAZON_PAYOUT_FEE_USAGE_REQUEST: "GET_AMAZON_PAYOUT_FEE_USAGE_REQUEST",
    GET_AMAZON_PAYOUT_FEE_USAGE_SUCCESS: "GET_AMAZON_PAYOUT_FEE_USAGE_SUCCESS",
    GET_AMAZON_PAYOUT_FEE_USAGE_FAILURE: "GET_AMAZON_PAYOUT_FEE_USAGE_FAILURE",

    CLEAR_BMF_DATA: "CLEAR_BMF_DATA",

    VALIDATE_OR_REFRESH_WEBHOOKS_REQUEST: "VALIDATE_REFRESH_WEBHOOKS_REQUEST",
    VALIDATE_OR_REFRESH_WEBHOOKS_SUCCESS: "VALIDATE_REFRESH_WEBHOOKS_SUCCESS",
    VALIDATE_OR_REFRESH_WEBHOOKS_FAILURE: "VALIDATE_REFRESH_WEBHOOKS_FAILURE",

    CONFIGURATION_CATCHUP_START_REQUEST: "CONFIGURATION_CATCHUP_START_REQUEST",
    CONFIGURATION_CATCHUP_START_SUCCESS: "CONFIGURATION_CATCHUP_START_SUCCESS",
    CONFIGURATION_CATCHUP_START_FAILURE: "CONFIGURATION_CATCHUP_START_FAILURE",
    CONFIGURATION_CATCHUP_START_CLEANUP: "CONFIGURATION_CATCHUP_START_CLEANUP",

    RECREATE_EXISTING_DOCUMENTS_REQUEST: "RECREATE_EXISTING_DOCUMENTS_REQUEST",
    RECREATE_EXISTING_DOCUMENTS_SUCCESS: "RECREATE_EXISTING_DOCUMENTS_SUCCESS",
    RECREATE_EXISTING_DOCUMENTS_FAILURE: "RECREATE_EXISTING_DOCUMENTS_FAILURE",

    RECREATE_ALL_DOCUMENTS_REQUEST: "RECREATE_ALL_DOCUMENTS_REQUEST",
    RECREATE_ALL_DOCUMENTS_SUCCESS: "RECREATE_ALL_DOCUMENTS_SUCCESS",
    RECREATE_ALL_DOCUMENTS_FAILURE: "RECREATE_ALL_DOCUMENTS_FAILURE",
    RECREATE_DOCUMENTS_CLEANUP: "RECREATE_DOCUMENTS_CLEANUP",

    DOWNLOAD_ALL_DOCUMENTS_REQUEST: "DOWNLOAD_ALL_DOCUMENTS_REQUEST",
    DOWNLOAD_ALL_DOCUMENTS_SUCCESS: "DOWNLOAD_ALL_DOCUMENTS_SUCCESS",
    DOWNLOAD_ALL_DOCUMENTS_FAILURE: "DOWNLOAD_ALL_DOCUMENTS_FAILURE",

    TOGGLE_ORDER_IMPORT_MODAL: "TOGGLE_ORDER_IMPORT_MODAL",
    TOGGLE_SHOW_AUTO_SETUP_MODAL: "TOGGLE_SHOW_AUTO_SETUP_MODAL",

    ORDER_IMPORT_REQUEST: "ORDER_IMPORT_REQUEST",
    ORDER_IMPORT_SUCCESS: "ORDER_IMPORT_SUCCESS",
    ORDER_IMPORT_FAILURE: "ORDER_IMPORT_FAILURE",
    ORDER_IMPORT_CLEANUP: "ORDER_IMPORT_CLEANUP",

    SET_TEST_MODE_REQUEST: "SET_TEST_MODE_REQUEST",
    SET_TEST_MODE_SUCCESS: "SET_TEST_MODE_SUCCESS",
    SET_TEST_MODE_FAILURE: "SET_TEST_MODE_FAILURE",

    TRIGGER_HEALTH_REPORT_REQUEST: "TRIGGER_HEALTH_REPORT_REQUEST",
    TRIGGER_HEALTH_REPORT_SUCCESS: "TRIGGER_HEALTH_REPORT_SUCCESS",
    TRIGGER_HEALTH_REPORT_FAILURE: "TRIGGER_HEALTH_REPORT_FAILURE",
    TRIGGER_HEALTH_REPORT_CLEANUP: "TRIGGER_HEALTH_REPORT_CLEANUP",

    LOAD_SIMPLE_ORGANIZATIONS_REQUEST: "LOAD_SIMPLE_ORGANIZATIONS_REQUEST",
    LOAD_SIMPLE_ORGANIZATIONS_SUCCESS: "LOAD_SIMPLE_ORGANIZATIONS_SUCCESS",
    LOAD_SIMPLE_ORGANIZATIONS_FAILURE: "LOAD_SIMPLE_ORGANIZATIONS_FAILURE",

    LOAD_NEXT_ORGANIZATIONS: "LOAD_NEXT_ORGANIZATIONS",

    CLEAR_FILTER_PROPERTIES: "CLEAR_FILTER_PROPERTIES",

    RESET_TO_REGULAR_ORGANIZATION_REQUEST: "RESET_TO_REGULAR_ORGANIZATION_REQUEST",
    RESET_TO_REGULAR_ORGANIZATION_SUCCESS: "RESET_TO_REGULAR_ORGANIZATION_SUCCESS",
    RESET_TO_REGULAR_ORGANIZATION_FAILURE: "RESET_TO_REGULAR_ORGANIZATION_FAILURE",

    CLEAR_STATE_ON_LOGIN: "CLEAR_STATE_ON_LOGIN",

    SAVE_GLOBAL_SETTINGS_REQUEST: "SAVE_GLOBAL_SETTINGS_REQUEST",
    SAVE_GLOBAL_SETTINGS_SUCCESS: "SAVE_GLOBAL_SETTINGS_SUCCESS",
    SAVE_GLOBAL_SETTINGS_FAILURE: "SAVE_GLOBAL_SETTINGS_FAILURE",
    GET_GLOBAL_SETTINGS_REQUEST: "GET_GLOBAL_SETTINGS_REQUEST",
    GET_GLOBAL_SETTINGS_SUCCESS: "GET_GLOBAL_SETTINGS_SUCCESS",
    GET_GLOBAL_SETTINGS_FAILURE: "GET_GLOBAL_SETTINGS_FAILURET",

    SET_AUDITED_ORGANIZATION: "SET_AUDITED_ORGANIZATION",

    GET_AUDIT_CHANGES_REQUEST: "GET_AUDIT_CHANGES_REQUEST",
    GET_AUDIT_CHANGES_SUCCESS: "GET_AUDIT_CHANGES_SUCCESS",
    GET_AUDIT_CHANGES_FAILURE: "GET_AUDIT_CHANGES_FAILURE",

    GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_REQUEST: "GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_REQUEST",
    GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_SUCCESS: "GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_SUCCESS",
    GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_FAILURE: "GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_FAILURE",

    SET_PARALLEL_TESTS_ORGANIZATION_REQUEST: "SET_PARALLEL_TESTS_ORGANIZATION_REQUEST",
    SET_PARALLEL_TESTS_ORGANIZATION_SUCCESS: "SET_PARALLEL_TESTS_ORGANIZATION_SUCCESS",
    SET_PARALLEL_TESTS_ORGANIZATION_FAILURE: "SET_PARALLEL_TESTS_ORGANIZATION_FAILURE",

    GET_PARALLEL_TESTS_DATA_REQUEST: "GET_PARALLEL_TESTS_DATA_REQUEST",
    GET_PARALLEL_TESTS_DATA_SUCCESS: "GET_PARALLEL_TESTS_DATA_SUCCESS",
    GET_PARALLEL_TESTS_DATA_FAILURE: "GET_PARALLEL_TESTS_DATA_FAILURE",

    EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_REQUEST:
        "EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_REQUEST",
    EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_SUCCESS:
        "EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_SUCCESS",
    EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_FAILURE:
        "EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_FAILURE",

    CREATE_BUG_REPORT_REQUEST: "CREATE_BUG_REPORT_REQUEST",
    CREATE_BUG_REPORT_SUCCESS: "CREATE_BUG_REPORT_SUCCESS",
    CREATE_BUG_REPORT_FAILURE: "CREATE_BUG_REPORT_FAILURE",
    TOGGLE_BUG_REPORT_MODAL: "TOGGLE_BUG_REPORT_MODAL",

    GET_ACTIVE_MILESTONES_REQUEST: "GET_ACTIVE_MILESTONES_REQUEST",
    GET_ACTIVE_MILESTONES_SUCCESS: "GET_ACTIVE_MILESTONES_SUCCESS",
    GET_ACTIVE_MILESTONES_FAILURE: "GET_ACTIVE_MILESTONES_FAILURE",

    GET_PROJECT_LABELS_REQUEST: "GET_PROJECT_LABELS_REQUEST",
    GET_PROJECT_LABELS_SUCCESS: "GET_PROJECT_LABELS_SUCCESS",
    GET_PROJECT_LABELS_FAILURE: "GET_PROJECT_LABELS_FAILURE",
};
